export default __webpack_public_path__ + "static/media/IMG_0037.cc2585f7.jpg";